import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UserPasswordEditDto } from 'src/app/api/exa';
import { UserRestService } from '../../api/exa/api/userRest.service';
import { AlertService } from '../../services/alert.service';
import { ModalController } from '@ionic/angular';
import { NavUrls } from 'src/app/enums/nav-urls';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-settings-dialog',
  templateUrl: './settings-dialog.component.html',
  styleUrls: ['./settings-dialog.component.scss'],
})
export class SettingsDialogComponent implements OnInit {
  // @Output() locDetection: EventEmitter<boolean>= new EventEmitter();

  userPasswordMessages = {
    oldPassword: [],
    newPassword: [],
    newPasswordConfirm: [],
  };

  userPasswordForm = { oldPassword: '', newPassword: '', newPasswordConfirm: '' };

  changePassword = false;

  hideOld = true;
  hideNew = true;
  hideConfirm = true;

  locDetect = null;

  dashboard = NavUrls.DASHBOARD_MAP;

  constructor(
    private userService: UserRestService,
    private alertService: AlertService,
    private modalCtrl: ModalController,
    private translate: TranslateService
  ) {}

  changeDetection($event) {
    this.locDetect = $event.detail.checked;
    // this.locDetection.emit(this.locDetect);
  }

  onClickPassword() {
    this.changePassword = true;
  }

  initUserPasswordForm() {
    // Form
    this.userPasswordForm.oldPassword = '';
    this.userPasswordForm.newPassword = '';
    this.userPasswordForm.newPasswordConfirm = '';
    // Messages
    this.initUserPasswordMessages();
  }

  initUserPasswordMessages() {
    // Messages
    this.userPasswordMessages.oldPassword = [];
    this.userPasswordMessages.newPassword = [];
    this.userPasswordMessages.newPasswordConfirm = [];
  }

  onClickSavePassword() {
    if (this.onChangeEditPasswordForm()) {
      const passwordEditDto: UserPasswordEditDto = {
        oldPassword: this.userPasswordForm.oldPassword,
        newPassword: this.userPasswordForm.newPassword,
      };
      this.userService.changeMyPasswordUsingPOST(passwordEditDto).subscribe(
        (_) => {
          this.initUserPasswordForm();
          this.alertService.openMessageToast(this.translate.instant('PASSWORD.CHANGE.SUCCESS'));
          this.dismiss();
        },
        (err) => {
          this.alertService.openAlertToast('Something goes wrong', 2000);
        }
      );
    }
  }
  onChangeEditPasswordForm() {
    this.initUserPasswordMessages();
    if (!this.userPasswordForm.oldPassword) {
      this.userPasswordMessages.oldPassword.push('FORMS.REQUIRED');
      return false;
    }
    if (!this.userPasswordForm.newPassword) {
      this.userPasswordMessages.newPassword.push('FORMS.REQUIRED');
      return false;
    }
    if (this.userPasswordForm.newPassword !== this.userPasswordForm.newPasswordConfirm) {
      this.userPasswordMessages.newPasswordConfirm.push('PASSWORD.NO_MATCH');
      return false;
    }
    return true;
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

  ngOnInit() {}
}
